import { CollideEvent, CollideId } from '../../defs/collide';
import type { PopcornBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { CornEffect } from '../effects/CornEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class PopcornCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: PopcornBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: PopcornBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    const collider = event.collider;

    // Attack only if basic block collider
    if (
      collider?.type === 'block' &&
      collider.entity.c.block.props.type === 'basic'
    ) {
      await this.attack();
      return true;
    }
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    await this.attack();
    return false;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;

    // Despawn block
    despawnBlockEntity(this.scene, this.entity);

    // Play break animation
    new CornEffect(this.scene, {
      subject: this.entity,
      spawnPopcorn: false,
    }).execute();
  }
}
